<template>
  <div class="info-button" @click="$emit('click')">
    <div class="info-button-inner"><Info class="icon" /></div>
  </div>
</template>

<script>
import Info from '@/assets/images/info.svg';
export default {
  components: {
    Info
  }
};
</script>

<style lang="scss" scoped>
.info-button {
  border: 5px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  transition-delay: 1s;
  cursor: pointer;
}
.info-button-inner {
  background-color: #fff;
  padding: 10px;
  border-radius: 50%;
  svg {
    display: block;
  }
}

.info-button-inner::before {
  position: absolute;
  display: block;
  content: '';
  border-radius: 50%;
  height: 32px;
  width: 32px;
  transform: scale(1);
  box-shadow: 0 0 0 0 rgba(0, 94, 184, 1);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 94, 184, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 94, 184, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 94, 184, 0);
  }
}
</style>
